import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from 'react-accessible-accordion';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  SectionHeader,
  Button,
  Paragraph,
  IconSVG,
  Heading,
  Link,
} from 'components';
import './Accordion.scss';

class Accordion extends Component {
  render() {
    const {
      backgroundColor,
      children,
      icon,
      headline,
      headingType,
      lead,
      description,
      lineColor,
      fontColors,
      additionalClass,
      index,
      expandFirst,
      id,
    } = this.props;

    return (
      <Section
        id={id}
        color={backgroundColor}
        additionalClass={`accordion__single ${additionalClass}`}
        fullwidth
      >
        <AccordionItem expanded={!!(index === 1 && expandFirst)}>
          <div className={'accordion__wrapper w-container'}>
            <Row className={'accordion__row no-gap'}>
              <Col sm={12} md={6}>
                {icon && (
                  <IconSVG
                    name={icon}
                    size={'big'}
                    color={'black'}
                    background={'white'}
                  />
                )}
                <Row className={'accordion__row no-gap'}>
                  {index && (
                    <Paragraph
                      additionalClass={'accordion__item-order text--bold'}
                      color={fontColors[0]}
                    >
                      {index}.
                    </Paragraph>
                  )}
                  <SectionHeader
                    size={'small'}
                    lineColor={lineColor}
                    fixed
                    headingType={headingType}
                    color={fontColors[0]}
                    additionalClass={'accordion__headline'}
                  >
                    {headline}
                  </SectionHeader>
                  <AccordionItemTitle
                    className={
                      'accordion__read-more--mobile hide-desktop hide-tablet'
                    }
                  >
                    <IconSVG name={'arrow-down'} color={lineColor} />
                  </AccordionItemTitle>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <div className={'accordion__intro-inner hide-mobile'}>
                  {lead && (
                    <Heading
                      type={3}
                      size={'medium'}
                      color={fontColors[1]}
                      additionalClass={'accordion__title'}
                    >
                      {lead}
                    </Heading>
                  )}
                  <Paragraph
                    color={fontColors[2]}
                    additionalClass={
                      'text--light accordion__description--header'
                    }
                    nested
                  >
                    {description}
                  </Paragraph>
                  <AccordionItemTitle>
                    <Link to={`#${id}`}>
                      <Button
                        id={`accordion-${id}`}
                        transparent
                        color={fontColors[0]}
                        additionalClass={'accordion__read-more'}
                      >
                        Read more
                      </Button>
                    </Link>
                  </AccordionItemTitle>
                </div>
              </Col>
            </Row>
          </div>

          <AccordionItemBody className={'anim-slide-in-top'}>
            <div className={'accordion__more'}>
              <div className={'w-container hide-desktop hide-tablet'}>
                {lead && (
                  <Heading
                    type={4}
                    size={'medium'}
                    color={fontColors[1]}
                    additionalClass={'accordion__title'}
                  >
                    {lead}
                  </Heading>
                )}
                <Paragraph
                  color={fontColors[2]}
                  additionalClass={
                    'text--light accordion__description--header'
                  }
                  nested
                >
                  {description}
                </Paragraph>
              </div>
              <div className={'hide-mobile'}>{children}</div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
      </Section>
    );
  }
}

Accordion.defaultProps = {
  backgroundColor: 'white',
  children: null,
  lineColor: '',
  fontColors: ['black', 'black', 'black'],
  expandFirst: false,
};

Accordion.propTypes = {
  backgroundColor: PropTypes.string,
  icon: PropTypes.string,
  headline: PropTypes.string.isRequired,
  lead: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  expandFirst: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  lineColor: PropTypes.string,
  fontColors: PropTypes.array,
};

export default Accordion;
